import React from 'react'
import UaeBloreHead from '../../UaeAttestation/UaeBlore/UaeBloreHead'
import PhilippinesBloreMain from './PhilippinesBloreMain'
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";

const PhilippinesBlore = () => {
  return (
    <div className="uaeBloreContainer">
    <UaeBloreHead head="Philippines Attestation in Bangalore" />
    <PhilippinesBloreMain />
  </div>
  )
}

export default PhilippinesBlore
